import { Alert, Backdrop, Box, Button, CircularProgress, Grid, Paper, TextField } from "@mui/material";
import MenuFrame from "../frames/menu_frame";
import { useState } from "react";
import { validIndianPin } from "../booking/booking_halper";
import { newClient, validName, validOptionalAddress, validRequiredAddress } from "./client_halper";

function NewClient() {
    const [inputErrors, setInputErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    const __error_handler = (test, vr, msg) => {
        if (test) {
            inputErrors[vr] = "";
            setInputErrors({ ...inputErrors });
        } else {
            inputErrors[vr] = msg;
            setInputErrors({ ...inputErrors });
        }
        return !test;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        const name = data.get("name");
        const client_id = data.get("client_id");
        const add_l1 = data.get("add_l1");
        const add_l2 = data.get("add_l2");
        const add_l3 = data.get("add_l3");
        const state = data.get("state");
        const pin = data.get("pin");

        var flag = true;
        if (__error_handler(validName(name), "name", "You have not entered a valid name.")) {
            flag = false;
        }
        if (__error_handler(client_id.length === 7, "client_id", "Client ID must be 7 char long.")) {
            flag = false;
        }
        if (__error_handler(validRequiredAddress(add_l1), "add_l1", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(validRequiredAddress(add_l2), "add_l2", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(validOptionalAddress(add_l3), "add_l3", "Invalid address line.")) {
            flag = false;
        }
        if (__error_handler(["Jharkhand", "Bihar", "Orrisa", "West Bangal"].includes(state), "state", "Must be an indian state")) {
            flag = false;
        }
        if (__error_handler(validIndianPin(pin), "pin", "You have entered an invalid pin code.")) {
            flag = false;
        }
        if (flag) {
            const _json = {
                name: name, client_id: client_id,
                add_l1: add_l1, add_l2: add_l2, add_l3: add_l3,
                state: state, pin: pin
            };

            newClient(_json).then((_) => {
                setAlertMessage({ severity: "success", message: "You have successfully added a client." });
                setIsLoading(false);
                event.target.reset();
            }).catch((err) => {
                setAlertMessage({ severity: "error", message: err['message'] });
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }

    const validateInputs = (e) => {
        setIsLoading(true);
        return true;
    }

    return (
        <MenuFrame>
            {alertMessage === null ? "" :
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                </Box>
            }
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid size={{ xs: 12, sm: 12 }} component="form" onSubmit={handleSubmit} noValidate>
                <Grid container spacing={2} component={Paper} sx={{ p: 2 }}>
                    <Grid size={{ xs: 12, sm: 8 }}>
                        <TextField variant="outlined" name="name" fullWidth error={inputErrors.name} type="text" helperText={inputErrors.name} slotProps={{ htmlInput: { maxLength: 35 } }} placeholder="Legal name of company" label="Company Name" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="client_id" fullWidth error={inputErrors.client_id} type="text" helperText={inputErrors.client_id} slotProps={{ htmlInput: { maxLength: 7 } }} placeholder="Ex: ABCD002" label="Client ID" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="add_l1" fullWidth error={inputErrors.add_l1} type="text" helperText={inputErrors.add_l1} placeholder="Line 1" slotProps={{ htmlInput: { maxLength: 30 } }} label="Address line 1" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="add_l2" fullWidth error={inputErrors.add_l2} type="text" helperText={inputErrors.add_l2} placeholder="Line 2" slotProps={{ htmlInput: { maxLength: 30 } }} label="Address line 2" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="add_l3" fullWidth error={inputErrors.add_l3} type="text" helperText={inputErrors.add_l3} placeholder="Line 3" slotProps={{ htmlInput: { maxLength: 30 } }} label="Address line 3 (Optional)" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 8 }}>
                        <TextField variant="outlined" name="state" fullWidth error={inputErrors.state} type="text" helperText={inputErrors.state} placeholder="State name" slotProps={{ htmlInput: { maxLength: 20 } }} label="State" defaultValue={"Jharkhand"} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <TextField variant="outlined" name="pin" fullWidth error={inputErrors.pin} type="text" helperText={inputErrors.pin} placeholder="Pincode" label="Pincode" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12 }}>
                        <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                    </Grid>
                </Grid>
            </Grid>
        </MenuFrame>
    );
}

export default NewClient;
